/*
 * @Author: nxf
 * @Date:2019-06-22
 * @LastEditTime: 2021-03-31 10:34:53
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\multiMediaResource\multiMediaResource.js
 * @Description: 多媒体资源
 */
'use strict';
angular.module('multiMediaResourceModule', [
    'multiMediaResourceLeftModule', // 多媒体资源左侧导航
    'multiMediaResourceRouterModule', // 多媒体资源路由
    'resCenPictureModule', // 图片素材
    'resCenVideoModule', // 视频素材
]);
